import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { UI } from 'src/apps/invest/common/shells/UI';
import { usePropertiesDashboardViewModel } from '../../models/PropertyDashboardViewModel';

export const WaitlistPosition: React.FC = () => {
  const { position } = usePropertiesDashboardViewModel();
  return (
    <UI containerPadding={0}>
      <Flex flex={1} justifyContent="center">
        <Flex
          maxWidth={['100%']}
          w={'100%'}
          backgroundSize={['cover', 'cover', 'cover', 'cover', '100%']}
          backgroundRepeat={'no-repeat'}
          flex={1}
          backgroundPosition={['center', 'center', 'bottom']}
          backgroundImage={[
            '/assets/gfx/blurred-properties-mobile.png',
            '/assets/gfx/blurred-properties-mobile.png',
            '/assets/gfx/blurred-properties.png',
          ]}>
          <Flex
            flexDirection={'column'}
            w={'100%'}
            maxW={'500px'}
            m={' 0 auto'}
            padding={['20px', '0']}
            alignItems="center">
            <TextBlock mt={'56px'} textAlign="center" weight="bold" fontSize="36px">
              You're in line!
            </TextBlock>
            <TextBlock mt={'9px'} maxW={'350px'} textAlign="center">
              Welcome to our priority access list. Stay tuned for announcements.
            </TextBlock>
            <Box
              mt={'30px'}
              background="linear-gradient(white, white) padding-box,linear-gradient(to bottom, #63AAFF, #C7E0FF, #C4A8FF) border-box"
              borderRadius="10px"
              px={'40px'}
              py="14px"
              border="2px solid transparent">
              <TextBlock textAlign="center" lineHeight="64px" fontSize="64px" weight="bold">
                {position}
              </TextBlock>
              <TextBlock weight="bold">investors ahead of you</TextBlock>
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </UI>
  );
};
